export default __webpack_public_path__ + "images/Tapclicks.98ab436c401d0020f116d2380312f1bd.svg";